import {ApiClient} from '@hconnect/apiclient'
import {Iso8601, TaskRepetition} from '@hconnect/common/types'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {Moment} from 'moment-timezone'

import {TasksApiPath} from '../../consts'
import {ProcessWorkOrderDueDatePreview, ProcessWorkOrderRepetitionInfoDto} from '../../types'

const QueryKey = 'get-pwo-due-dates-preview-items'

type GetDueDatesPreviewRequest<TDate extends Moment | Iso8601 = Moment> = {
  dueDate: TDate
  repetitionInfo: ProcessWorkOrderRepetitionInfoDto
  requestedItemsCount: number
  createdEntitiesCount: number
}

export const useProcessWorkOrderDueDatesPreview = (
  plantId: string,
  settings: TaskRepetition,
  dueDatePreview: GetDueDatesPreviewRequest,
  defaultStartDate?: Moment
) => {
  const path = `${TasksApiPath.PROCESS_WORK_ORDERS}/${plantId}/process-work-order-schedules/due-dates-preview`

  return useQuery<ProcessWorkOrderDueDatePreview, AxiosError>({
    queryKey: [QueryKey, settings, defaultStartDate, dueDatePreview, plantId],
    queryFn: async () => {
      if (defaultStartDate) {
        dueDatePreview.dueDate = defaultStartDate
      }
      const response = await ApiClient.axiosInstance.post<ProcessWorkOrderDueDatePreview>(
        path,
        dueDatePreview
      )

      return response.data
    }
  })
}
